import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from './app-config';
import { BaseService } from './base/base.service';
import { ListResponse } from '../interfaces';
import { CompSearchContext } from '../models';

@Injectable()
export class CompSearchRangeService extends BaseService<any> {

  constructor(
    protected http: HttpClient,
    protected config: AppConfig
  ) {
    super(http, config);
  }

  public getRangeComparables(context: CompSearchContext, type: string): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}/${context.baseUrl}/range-comparables/${type}`);
  }

  public getRangeResults(context: CompSearchContext, type: string): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}/${context.baseUrl}/range-results/${type}`);
  }

  public getRangeDiscussion(context: CompSearchContext): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}/${context.baseUrl}/range-discussion`);
  }

  public getInitialRangeDetails(
    compSearchId: number,
    jurisdictionId: number,
    pliTypeId: number,
    pliAvgTypeId: number
  ): Observable<any> {
    // tslint:disable-next-line
    const apiUrl = `${this.getResourceUrl()}/compsearch/${compSearchId}/jurisdiction/${jurisdictionId}/pli/${pliTypeId}/pli-avg/${pliAvgTypeId}/range-details/initial`;

    return this.http.get<ListResponse<any>>(apiUrl);
  }

  public getFinalRangeDetails(
    compSearchId: number,
    jurisdictionId: number,
    pliTypeId: number,
    pliAvgTypeId: number
  ): Observable<any> {
    // tslint:disable-next-line
    const apiUrl = `${this.getResourceUrl()}/compsearch/${compSearchId}/jurisdiction/${jurisdictionId}/pli/${pliTypeId}/pli-avg/${pliAvgTypeId}/range-details/final`;

    return this.http.get<any>(apiUrl);
  }

  protected getResourceUrl() {
    return `${this.config.getCompSearchApiUrl()}/v1`;
  }

}
